// frontend/src/components/ui/DataTableMobileCard.tsx
import React from 'react';

interface DataTableMobileCardProps {
  children: React.ReactNode;
  onClick?: () => void;
}

export function DataTableMobileCard({ children, onClick }: DataTableMobileCardProps) {
  const baseClasses = 'block w-full bg-white rounded-xl border border-gray-200 shadow-sm p-4 min-h-[44px] transition-colors hover:border-gray-300';
  const interactionClasses = onClick ? 'cursor-pointer active:bg-gray-50' : '';

  return (
    <div
      data-testid="datatable-mobile-card"
      className={`${baseClasses} ${interactionClasses}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {children}
    </div>
  );
}
